<template>
<div class="chapter">
<div class="inner_page">
<p class="right" id="tp"><span class="big1"><strong>The Monkey Wrench Gang</strong></span><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="right">Edward Abbey</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795317361_epub_tp_r1.vue?b0c8cdd6